import React from "react";
import FormType, { FieldConfigs } from "../../../../../shared/components/FormType";
import { UserFormWrapper } from "../../Content/Styled";

interface FormContainerProps {
  validated: boolean;
  requiredData: any;
  isOwnProfile: boolean;
  mergeUserPassword: Function;
}

const FormContainerChangePassword = ({ validated, requiredData, isOwnProfile, mergeUserPassword }: FormContainerProps) => {

  const Confirmationfields: FieldConfigs[] = isOwnProfile ? [
    {
      label: "Mật khẩu hiện tại",
      type: "text",
      key: "old_password",
    },
    {
      label: "Mật khẩu mới",
      type: "text",
      key: "new_password",
    },
    {
      label: "Xác nhận mật khẩu mới",
      type: "text",
      key: "new_password_confirm",
    }
  ] : [];

  const handleChangePassword = (updatePassword: any) => {
    const updatedPassword = {
      ...updatePassword,
      old_password: updatePassword.old_password,
      new_password: updatePassword.new_password,
      new_password_confirm: updatePassword.new_password_confirm
    }
    mergeUserPassword(updatedPassword);
  }

  return (
    <UserFormWrapper>
        { isOwnProfile && (
            <FormType
                title={"Xác minh tài khoản người dùng hiện tại"}
                fields={Confirmationfields}
                validated={validated}
                mergeFormData={handleChangePassword}
            />
        )}
    </UserFormWrapper>
  );
};

export default FormContainerChangePassword;
